let ctx = null;
const KEY = "xver_sound";

export const isSoundOn = () => localStorage.getItem(KEY) !== "off";
export const setSoundOn = (on) => localStorage.setItem(KEY, on ? "on" : "off");

export const unlockAudio = () => {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
};

const tone = (freq, dur, vol, type = "triangle", delay = 0) => {
  if (!ctx || !isSoundOn()) return;
  const t = ctx.currentTime + delay;
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(ctx.destination);
  o.start(t);
  o.stop(t + dur + 0.02);
};

export const playTick = () => tone(1400 + Math.random() * 200, 0.045, 0.07);
export const playWin = () => { tone(660, 0.12, 0.12, "sine"); tone(880, 0.12, 0.12, "sine", 0.1); tone(1320, 0.22, 0.12, "sine", 0.2); };
export const playLose = () => { tone(300, 0.15, 0.1, "sine"); tone(200, 0.25, 0.1, "sine", 0.12); };
